import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import Global from '../../../store/global-selectors';
import * as GridConfigApi from '../../../store/grid-config.api';
import * as CustomersActions from '../../../store/customers/customers.actions';
import * as NavActions from '../../../store/customers/nav/customers.nav.actions';
import { ModalService } from 'ui-components/services/modal-service';
import { customerGridChangeColumns } from '../../../store/customers/grid/customers.grid.actions';
import { saveUserSettingGridConfig } from '../../../store/user/user.actions';
import { SaveShippingFilterviewModalContainer } from '../../../containers/save-shipping-filterview-modal-container';
import { DeleteShippingFilterviewModalContainer } from '../../../containers/delete-shipping-filterview-modal-container';
import { EditShippingFilterviewModalContainer } from '../../../containers/edit-shipping-filterview-modal-container';
import * as Actions from './customers.filtering.actions';

export const updateGridWithNoFilters = (action$) => {
  return action$.pipe(
    ofType(
      Actions.CUSTOMERS_AUTOSWITCH_FILTERVIEW_DEFAULT,
      Actions.CUSTOMERS_DELETE_FILTERVIEW_SUCCESS,
      Actions.CUSTOMERS_SAVE_NEW_FILTERVIEW_SUCCESS,
      Actions.CUSTOMERS_SAVE_EXISTING_FILTERVIEW_SUCCESS,
    ),
    map(() => {
      return CustomersActions.silentRequestGetCustomers();
    }),
  );
};

export const switchActiveFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_SWITCH_FILTERVIEW),
    mergeMap(() => {
      return of(CustomersActions.silentRequestGetCustomers(), NavActions.clearSearchInput());
    }),
  );
};

export const getSavedFilterViewsRequest = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_GET_SAVED_FILTERVIEWS_REQUEST),
    mergeMap(() => {
      return GridConfigApi.getAllCustomersGridConfigs().pipe(
        map((savedFilterViews) => {
          return Actions.getSavedFilterViewsSuccess(savedFilterViews);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const saveNewFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_SAVE_NEW_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveNewCustomersGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveNewFilterViewSuccess(filterView);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const saveExistingFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_SAVE_EXISTING_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveExistingCustomersGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveExistingFilterViewSuccess(filterView);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const updateSavedViewGridConfig = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_SAVE_NEW_FILTERVIEW_SUCCESS, Actions.CUSTOMERS_SAVE_EXISTING_FILTERVIEW_SUCCESS),
    mergeMap((action) => {
      const state = getState();
      const { filterView } = action;
      const { gridViewId, filterViewId } = filterView;
      const gridConfig = Global.selectCustomersGridCurrentViewGridConfigOrDefault(state, {
        statusViewId: gridViewId,
        activeFilterViewId: 'custom',
      });

      return of(
        customerGridChangeColumns(gridViewId, filterViewId, gridConfig),
        saveUserSettingGridConfig('customers', gridViewId, filterViewId, gridConfig),
      );
    }),
  );
};

export const deleteFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMERS_DELETE_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      const { filterView } = action;
      return GridConfigApi.deleteGridConfig(filterView).pipe(
        map(() => {
          return Actions.deleteFilterViewSuccess(filterView);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const launchSaveShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_CUSTOMERS_SAVE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: SaveShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchEditShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_CUSTOMERS_EDIT_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: EditShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchDeleteShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_CUSTOMERS_DELETE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: DeleteShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};
